import { render, staticRenderFns } from "./WCode.vue?vue&type=template&id=5b136907&scoped=true"
import script from "./WCode.vue?vue&type=script&lang=js"
export * from "./WCode.vue?vue&type=script&lang=js"
import style0 from "./WCode.vue?vue&type=style&index=0&id=5b136907&prod&lang=scss"
import style1 from "./WCode.vue?vue&type=style&index=1&id=5b136907&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b136907",
  null
  
)

export default component.exports